<template>

  <v-container fluid pa-0 fill-height grid-list-md>
    <v-layout row fill-height>
      <div v-if="side_menu"
           style="background-color: #dee5ea; overflow:hidden; z-index: 1; flex: 0 0 198px; margin: 0px 0px 0px 0px">
        <v-card id="header_div" flat style="margin: 0px 0px 5px 0px; min-height: 155px; position: relative"
                :color="colors.timeline_bg">
          <v-layout ma-0 style="position: absolute; right:0px;">
            <v-btn v-if="side_menu" style=" z-index: 10;" flat  icon @click="side_menu = !side_menu">
              <v-icon>close</v-icon>
              <!--<v-icon v-else>menu</v-icon>-->
            </v-btn>
          </v-layout>
          <v-card-title >
            <h2 style="margin-top: 10px;">{{ meeting.name }}</h2>
            <span style="margin-top: 8px;"><b>Date: </b>{{ moment(meeting.meeting_date).format('YYYY-MM-DD') }}</span>
            <br>
            <span style="margin-top: 8px;"><b>Location: </b>{{meeting.city }}, {{meeting.state }} </span>
          </v-card-title>
        </v-card>
        <div style="background-color: white; height: 3px; width: inherit"></div>

        <v-text-field
          light
          label="Solo"
          append-icon="search"
          placeholder="Search"
          solo
          hide-details
          v-model="searchText"
          @input="searchTextChanged"
          style="margin-right: 15px; margin-left: 15px; margin-top: 15px;"
        ></v-text-field>


        <v-layout d-flex column ma-3 pa-3 class="filterHolder">

          <span> Select transcription segment based on organizers' tags</span>
          <v-layout row align-center justify-start>
            <v-checkbox
              hide-details
              :color="colors.select_all"
              v-model="selectAllTag"
              @change="selectcheckboxChanged"
            ></v-checkbox>
            <v-btn
              @click="selectAllPressed()"
              :color="colors.select_all"
              dark
              flat
              style="width:80px;"
            >Select All 
            </v-btn>
          </v-layout>
          <template v-for="(item, index) in org_tags">
            <v-layout row align-center justify-start>
              <v-checkbox
                hide-details
                :key="index + 'checkbox'"
                :color="item.color"
                v-model="item.active"
                @change="checkboxChanged"
              ></v-checkbox>
              <v-btn
                :key="index + 'normal'"
                @click="bClicked(item)"
                :color="item.color"
                dark
                style="width:100px;"
              >{{ item.name}}
              </v-btn>
            </v-layout>
          </template>
        </v-layout>

      <!-- Layout for report view button -->
      <v-layout d-flex column ma-3 pa-3 class="filterHolder">
          <span style="text-align:center"> Click to open</span>
          <v-layout column align-center justify-center>
            <v-btn id="rpButton"
              @click="openReportView()"
              :color="colors.select_all"
              style="width:130px;color: white;"
            > Summary 
            </v-btn>
            <v-btn id="tsButton"
              @click="openTranscriptView()"
              :color="colors.select_all"
              style="width:130px;color: white;"
            > Transcript 
            </v-btn>
          </v-layout>
        </v-layout>
        
        <!--<v-layout d-flex ma-3 pa-1 class="filterHolder" column>-->
        <!--<span>  Sort based on attendees feedback</span>-->
        <!--<v-overflow-btn-->
        <!--v-model="sortFilter"-->
        <!--:items="dropdown_sort"-->
        <!--label="Sort by user feedback"-->
        <!--&gt;</v-overflow-btn>-->
        <!--<v-overflow-btn-->
        <!--v-model="sortDirection"-->
        <!--:items="dropdown_sort_direction"-->
        <!--label="Direction"-->
        <!--&gt;</v-overflow-btn>-->
        <!--</v-layout>-->

      </div>

      <v-flex style="overflow: hidden;">
        <v-layout column>
          <v-flex>
            <!--<v-layout row justify-space-between fill-height style="position: absolute; height: 50px;">-->
            <!--<v-btn v-if="!side_menu" style=" z-index: 10;" flat dark icon @click="side_menu = !side_menu">-->
            <!--&lt;!&ndash;<v-icon v-if="side_menu">close</v-icon>&ndash;&gt;-->
            <!--<v-icon>menu</v-icon>-->
            <!--</v-btn>-->
            <!--&lt;!&ndash;<v-spacer></v-spacer>&ndash;&gt;-->
            <!--&lt;!&ndash;<v-btn style=" z-index: 10;" flat dark icon @click="topic_card_open = !topic_card_open"><v-icon v-if="topic_card_open">remove</v-icon><v-icon v-else>add</v-icon></v-btn>&ndash;&gt;-->
            <!--</v-layout>-->
            <v-card id="topcardid" style="border-radius: 0px; " v-if="topic_card_open" :color="colors.timeline_bg" flat light
                    class="topcard">
              <!--<resize-observer @notify="topDivResized" />-->
              <v-card-actions style="padding: 5px">
                <v-layout row align-start justify-start>
                  <v-layout ma-0 row align-center justify-start style="flex: 0 0 20px;">
                    <v-btn v-if="!side_menu" style=" z-index: 10;" flat  icon @click="side_menu = !side_menu">
                      <!--<v-icon v-if="side_menu">close</v-icon>-->
                      <v-icon>menu</v-icon>
                    </v-btn>
                  </v-layout>
                  <!--<v-flex>-->
                  <!--<div><b>Topics:</b></div>-->
                  <!--</v-flex>-->
                  <v-flex>
                    <span style="font-size: 15px;"><b>Topics:</b></span>
                    <template v-for="(item,index) in phrases">
                      <v-btn
                        dark
                        small
                        :key='index+"phrase"'
                        :color="colors.no_tag"
                        round
                        :outline="!item.active"
                        @click="phraseClicked(index)"
                        style="margin: 5px; font-size: 15px; text-transform: none !important;"
                      >{{item.phrase}}
                      </v-btn>
                    </template>
                  </v-flex>
                    <!-- <v-flex>
                      <v-btn style=" z-index: 5" flat icon small @click="closeReportView()">
                      <v-icon>close</v-icon>
                      </v-btn>
                  </v-flex> -->
                </v-layout>
              </v-card-actions>
            </v-card>
            <v-card style="border-radius: 0px; border-top: #838484 solid 1px; border-bottom: #838484 solid 1px; " flat dark :color="colors.timeline_bg">
              <v-card-actions id="top-card" style="height: 60px; padding: 5px; padding-bottom: 0px">
                <template>
                  <div v-on:click="timelineClicked()" id="chart-timeline"></div>
                </template>
              </v-card-actions>
            </v-card>
            <v-toolbar flat height="36px" :color="colors.timeline_bg"
                       style="border-bottom: #838484 solid 1px; padding: 0px;">
              <v-toolbar-title v-if="filter_empty" style="margin: 0px; color: red; font-size: 15px">No Results</v-toolbar-title>
              <v-spacer></v-spacer>
              <!--<v-divider vertical></v-divider>-->

              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-toolbar-title style="margin: 0px; font-size: 15px">Select Attendees Feedback:&nbsp;&nbsp;</v-toolbar-title>
              <v-divider vertical></v-divider>

              <v-overflow-btn
                v-model="sortFilter"
                :items="dropdown_sort"
                label="Sort by user feedback"
                hide-details
                class="pa-0"
                overflow
                style="flex: 0 0 250px; font-size:15px"
              ></v-overflow-btn>

              <v-divider
                class="mr-2"
                vertical
              ></v-divider>

              <v-toolbar-items class="hidden-sm-and-down">
                <v-btn :disabled="feedback_loop.length === 0" flat small @click="feedbackUpClicked">
                  <v-icon>arrow_upward</v-icon>
                </v-btn>
              </v-toolbar-items>

              <v-toolbar-title style="margin: 0px; flex: 0 0 100px;">{{feedback_obj.value}}</v-toolbar-title>

              <v-toolbar-items class="hidden-sm-and-down">
                <v-btn :disabled="feedback_loop.length ===0" flat small @click="feedbackDownClicked">
                  <v-icon>arrow_downward</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
          </v-flex flex-row>
          <v-flex id="fullContainer" d-flex>
          <!-- right here -->
          <v-flex id="reviewBoxContainer" style="width:50%;">
            <div id="revContainer" style="margin: 0px;">
              <div style="display:flex; flex-direction: row;">
                <div style="width: 50vw"><h3 style="margin-top: 5px">Summary</h3></div>
                <div style="width: 50vw; display:flex; justify-content:flex-end">
                  <v-btn style=" z-index: 5;margin:2px" flat icon small @click="closeReportView()">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
             </div>
             <div id="summary-container" style="height:40%; overflow: auto; margin-bottom:10px; border: solid thin lightgray;">
              <v-flex id="summary-parent" style="display:flex; flex-direction: column;">
                <v-flex>
                    <template v-for="(item, index) in sum_data">
                      <v-layout row class="sum-row" style="margin: 2px; font-size:15px" :id="'sumrow' + index" @click="highlightSumText(item, index)">
                        <!-- <v-icon style="margin: 2px">person</v-icon> -->
                        <!-- <span style="margin: 2px">{{item.org_tag}}</span> -->
                        <!-- <v-icon style="margin: 2px">people</v-icon> -->
                        <!-- <span style="margin: 2px"> / {{item.att_tag}}</span> -->
                        <span style="margin: 2px">{{item.text}}</span>
                        <!-- <span style="margin: 2px"> - {{item.att_tag}}</span> -->
                      </v-layout>
                    </template>
                  </v-flex>
              </v-flex>
             </div>
              <div>
              <b-form>
                <b-form-input type="hidden" id="noticeEditorContent"></b-form-input>
                <div>
                <trix-editor input="noticeEditorContent" id="x" style="overflow: auto; min-height: 200px"></trix-editor>
                </div>
                <div>
                <v-btn id="import-trix-content"
                @click="importTrixContent()"
                :color="colors.select_all"
                style="width:120px; color: white; margin-top: 5px;">
                Import</v-btn>
                <v-btn id="clear-trix-content"
                @click="clearTrixContent()"
                :color="colors.select_all"
                style="width:120px; color: white; margin-top: 5px;">
                Clear</v-btn>
                <v-btn id="save-trix-content"
                @click="saveTrixContent()"
                :color="colors.select_all"
                style="width:120px; color: white; margin-top: 5px;">
                Print</v-btn>
                </div>
                <!-- <v-button type="button" class="btn btn-danger" id="clear-trix-content" style="margin-top: 10px;">Clear</button> -->
                <!-- <v-button type="button" class="btn btn-success" id="save-trix-content" style="margin-top: 10px;">Save</button> -->
              </b-form>
              </div>
            </div>
          </v-flex>
          <v-flex id="cardContainer" style="width: 50%">
            <div style="display:flex; flex-direction:">
              <div style="width: 50vw"><h3 style="margin-top: 5px">Transcript</h3></div>
              <div style="width: 50vw; display:flex; justify-content:flex-end">
                  <v-btn style=" z-index: 10;margin:2px" flat icon small @click="closeTranscriptView()">
                    <v-icon>close</v-icon>
                  </v-btn>
                </div>
            </div>
            <div id="dataContent" style="overflow:scroll; height: 100%">
              <v-flex v-for="(item,index) in meeting.transcript_set" d-flex>
                <v-card v-if="!Array.isArray(item)" :id="'trans'+item.id" :color="colors.card_bg" :key="index + 'card'"
                        light>
                  <v-card-title>
                    <v-layout row>
                      <v-layout column style="width: 80%">
                        <v-layout row justify-start align-center>
                          <v-flex>
                            <v-btn
                              v-if="item.organizer_tag != null"
                              :key="index + 'cardBut'"
                              :color="getOrgTag(item.organizer_tag.answer).color"
                              dark
                              depressed
                            >{{ getOrgTag(item.organizer_tag.answer).name }}
                            </v-btn>
                            <v-btn
                              v-else
                              :key="index + 'cardBut'"
                              :color="getOrgTag('notag').color"
                              dark
                              depressed
                            >{{ getOrgTag('notag').name }}
                            </v-btn>
                            <v-chip
                              v-if="item.phrase !== null"
                              :v-model="item.phrase"
                              :key='index+"tag1"'
                              :color="colors.phrase"
                            >{{item.phrase.phrase}}
                            </v-chip>
                            <span style="margin: 0px 0px 0px 7px; font-size: 20px"><v-icon>access_time</v-icon> {{getTimePassed(item)}}</span>
                            <span style= "margin: 0px 0px 0px 7px; font-size: 20px">
                              <v-btn small round :color=colors.timeline_bg @click="importToReport(item)">
                                <!-- <v-icon>arrow_forward</v-icon> -->
                                Import to Report
                              </v-btn>
                            </span>
                          </v-flex>
                        </v-layout>
                        <text-highlight class="note" :queries="getQueries(item)">{{item.text}}</text-highlight>
                      </v-layout>
                      <v-spacer></v-spacer>
                      <v-layout ma-0 align-center justify-center column fill-height>
                        <span>Attendees Feedback</span>
                        <div :id="'bc'+index" style="width: 200px;height: 200px;">
                        </div>
                      </v-layout>
                      {{createBarChart(index,item)}}
                    </v-layout>
                    <!--<v-layout ma-1 row justify-start >-->
                    <!--<v-flex >-->
                    <!--<span><b style="font-size: 17px;">Attendees Feedback:</b> </span>-->
                    <!--<code v-if="getNumberOfAttendeesTag(item,'A') !== 0" :style="'color:' +getAttendeeTag('A').color +';'">{{getAttendeeTag('A').name}}:{{getNumberOfAttendeesTag(item,'A')}}</code>-->
                    <!--<code v-if="getNumberOfAttendeesTag(item,'B') !== 0" :style="'color:' +getAttendeeTag('B').color +';'">{{getAttendeeTag('B').name}}:{{getNumberOfAttendeesTag(item,'B')}}</code>-->
                    <!--<code v-if="getNumberOfAttendeesTag(item,'C') !== 0" :style="'color:' +getAttendeeTag('C').color +';'">{{getAttendeeTag('C').name}}:{{getNumberOfAttendeesTag(item,'C')}}</code>-->
                    <!--<code v-if="getNumberOfAttendeesTag(item,'D') !== 0" :style="'color:' +getAttendeeTag('D').color +';'">{{getAttendeeTag('D').name}}:{{getNumberOfAttendeesTag(item,'D')}}</code>-->
                    <!--<code v-if="getNumberOfAttendeesTag(item,'E') !== 0" :style="'color:' +getAttendeeTag('E').color +';'">{{getAttendeeTag('E').name}}:{{getNumberOfAttendeesTag(item,'E')}}</code>-->
                    <!--</v-flex>-->
                    <!--</v-layout>-->
                  </v-card-title>

                  <!--<v-card-text class="note">-->
                  <!--{{item.text}}-->
                  <!--</v-card-text>-->
                  <v-card-actions v-if="getUser().can_edit">
                    <v-btn small light color="milk" @click="editClicked(item)">Edit</v-btn>
                  </v-card-actions>
                </v-card>
                <div v-else class="collapsed_div">
                  <v-btn disabled flat style="visibility: hidden">{{pluralize('transcript card', item.length, true)}}
                    collapsed
                  </v-btn>
                  <v-icon style="font-size: 40px">more_vert</v-icon>
                  <v-btn disabled flat>{{pluralize('transcript card', item.length, true)}} collapsed</v-btn>
                </div>
              </v-flex>
            </div>
          </v-flex>
          <!-- right here -->
        </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog v-model="dialog" width="800" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Edit
        </v-card-title>

        <v-card-text>
          <v-layout row justify-space-between>
            <v-flex xs12 sm6 md5>
              <v-select
                v-model="editItem.editTag"
                :items="org_tags"
                attach
                chips
                label="Tag"
              >
                <template v-slot:selection="data">
                  <v-chip :color="data.item.color" dark label>
                    {{ data.item.text }}
                  </v-chip>
                </template>
              </v-select>
            </v-flex>

            <v-flex xs12 sm6 md5>
              <v-select
                v-model="editItem.editTopic"
                :items="phrases"
                attach
                chips
                label="Topic"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-textarea
            v-model="editItem.text"
            auto-grow
            box
            label="Text"
            rows="1"
          ></v-textarea>

        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="savePressed">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>


</template>

<script>
  /* eslint-disable */

  import axios from 'axios'
  import swal from 'sweetalert2'
  import router from '../../router'
  import {EnhancedCheck} from 'vue-enhanced-check'
  import VueSlideBar from '../thirdparty/VueSliderBar'
  import moment from 'moment'
  import VueScrollTo from 'vue-scrollto'
  import tagJson from '../../../static/michael-morris-tagged.json'

  export default {
    name: 'Meeting',
    components: {EnhancedCheck, VueSlideBar},

    data: () => ({
      dialog: false,
      loadedData: {},
      meeting: {},
      loading: true,
      errored: false,
      searchText: '',
      org_tags: [],
      attendee_tags: [],
      timelineWidth: 1000,
      timelineData: [],
      phrases: [],
      sortFilter: 'None',
      sortDirection: 'High to Low',
      dropdown_sort: ['None'],
      dropdown_sort_direction: ['Low to High', 'High to Low'],
      feedback_loop: [],
      feedback_obj: {
        index: 0,
        value: '',
      },
      editItem: {},
      selectedElemenet: null,
      selectedSumElement: null,
      selectAllTag: true,
      colors: {
        top_card: '#355f7b',
        card_bg: '#f5f8fa',
        card_highlight: '#f9f4ca',
        highlighter: '#e4d733',
        sidebar_bg: '#DCDCDC',
        bar_chart: '#7a7a7a',
        timeline_deselect: '#686b6b',
        no_tag: '#404142',
        select_all: '#2B4A5B',
        phrase: '#e0e0e0',
        timeline_bg: "#dee5ea",
      },
      filter_empty: false,
      ts_view: true,
      rp_view: true,
      side_menu: true,
      topic_card_open: true,
      any_circle_selected: false,
      sum_data: [],
      myNote: ""
    }),
    mounted () {
      this.checkLoggedIn()
      this.createTimeline()
    },
    created () { // would work in 'ready', 'attached', etc.
      window.addEventListener('resize', () => {
        this.createTimeline()
        this.resizeCardBox()
      })
    },
    methods: {
      // Launch report view and populate summary
      openReportView(){
        if(this.ts_view && !this.rp_view){
          var w = String(document.getElementById('fullContainer').clientWidth / 2) + "px";
          document.getElementById('rpButton').disabled = true;
          document.getElementById('reviewBoxContainer').style.width = w
          document.getElementById('reviewBoxContainer').style.display = "block"
          document.getElementById('cardContainer').style.width = w
          document.getElementById('cardContainer').style.display = "block"
          this.clearTrixContent()
          this.rp_view = true;
        }
        else if(!this.ts_view && !this.rp_view){
          var w = String(document.getElementById('fullContainer')).clientWidth + "px";
          document.getElementById('reviewBoxContainer').style.width = w
          document.getElementById('reviewBoxContainer').style.display = "block"
          document.getElementById('rpButton').disabled = true;
          this.clearTrixContent()
          this.rp_view = true;
        }
        // this.populateSummary()
      },
      openTranscriptView(){
        if(this.rp_view && !this.ts_view){
          var w = String(document.getElementById('fullContainer').clientWidth / 2) + "px";
          document.getElementById('cardContainer').style.width = w
          document.getElementById('tsButton').disabled = true;
          document.getElementById('cardContainer').style.display = "block"
          document.getElementById('reviewBoxContainer').style.width = w
          document.getElementById('reviewBoxContainer').style.display = "block"
          this.ts_view = true;
        }
        else if(!this.rp_view && !this.ts_view){
          var w = String(document.getElementById('fullContainer')).clientWidth + "px";
          document.getElementById('cardContainer').style.width = w
          document.getElementById('cardContainer').style.display = "block"          
          document.getElementById('tsButton').disabled = true;
          this.ts_view = true;
        }
        // this.populateSummary()
      },
      closeReportView(){
        if(this.rp_view){
          var w = String(document.getElementById('fullContainer')).clientWidth + "px";
          document.getElementById('cardContainer').style.width = w
          document.getElementById('rpButton').disabled = false
          document.getElementById('reviewBoxContainer').style.width = "0px"
          document.getElementById('reviewBoxContainer').style.display = "None"
          this.rp_view = false
        }
      },
      closeTranscriptView(){
        if(this.ts_view){
          var w = String(document.getElementById('fullContainer').clientWidth * 2) + "px";
          document.getElementById('reviewBoxContainer').style.width = w
          document.getElementById('tsButton').disabled = false
          document.getElementById('cardContainer').style.width = "0px"
          document.getElementById('cardContainer').style.display = "None"
          this.ts_view = false
        }
      },
      importTrixContent(){
        // Import summary content into Trix editor
        var w = String((document.getElementById('revContainer').clientHeight) * 2 / 5) + "px";
        document.getElementById('x').style.height = w;
        var fill_text = ""
        for (var i in this.sum_data) {
            fill_text = fill_text + this.sum_data[i].text + "\n"
        }
        var element = document.querySelector("trix-editor")
        element.editor.setSelectedRange([0, 0])
        element.editor.insertString(fill_text)
      },
      clearTrixContent(){
        // clear trix-editor content
        var element = document.querySelector("trix-editor")
        element.editor.setSelectedRange([0, 0])
        element.editor.loadHTML("")
      },
      saveTrixContent(){
          // write saving code here
          var element = document.querySelector("trix-editor")
          var divContents = element.value;
          var printWindow = window.open('', '', 'height=400,width=800');
          var titleText = '<html><head><title>' + this.meeting.name + " Report" + '</title>'
          printWindow.document.write(titleText);
          printWindow.document.write('</head><body >');
          printWindow.document.write(divContents);
          printWindow.document.write('</body></html>');
          printWindow.document.close();
          printWindow.print();
      },
      importToReport(item){
        console.log(item)
        var cardSumQuery = []
        var att_tags = []
        for (var j in item.attendeetag_set){
          att_tags.push(item.attendeetag_set[j].answer)
        }
          
        var org_tag = null;
        if(item.organizer_tag){
          org_tag = item.organizer_tag.answer
        } 

        var obj = {
          "text": item.text,
          "org_tag": org_tag,
          "att_tag": att_tags
        }

        cardSumQuery.push(obj)

        // console.log(cardSumQuery)

        var element = document.querySelector("trix-editor")
        element.editor.setSelectedRange(element.editor.getDocument().getLength())
        var cardSum = ""
        axios.post('http://swadhwa.pythonanywhere.com/summarize', {
          text: JSON.stringify(cardSumQuery),
          title: this.meeting.name,
        })
        .then((res) => {
          console.log(res.data)
          cardSum = res.data;
        })

        var temp_text = item.text.split(".")
        var max_len = 0;
        var biggest_text = ""
        for (var j in temp_text){
          if(temp_text[j].length > max_len){
            biggest_text = temp_text[j]
            max_len = temp_text[j].length
          }
        }

        element.editor.insertString(biggest_text)

        // element.editor.insertString(cardSum)
        // console.log(element.editor.getDocument().getLength())
        // console.log(cardSum)
      },
      highlightSumText(item, index){
        if(this.selectedSumElement){
          this.selectedSumElement.style.backgroundColor = "white"
          this.selectedSumElement = null;
        }
        this.selectedSumElement = document.getElementById("sumrow" + index)
        this.selectedSumElement.style.backgroundColor = this.colors.card_highlight
        var notes = document.getElementsByClassName("note")
        for (var i in notes){
          var note = String(notes[i].textContent)
          // console.log(String(notes[i].textContent))
          if(note === undefined){
            // pass 
          } 
          else if(note.includes(item.text)){
            // this.myNote = item.text
            // console.log(notes[i].parentNode.parentNode.parentNode.parentNode.id)
            this.scrollToCard(String(notes[i].parentNode.parentNode.parentNode.parentNode.id).substring(5), true) 
          }
        }
      },
      // create the summary for the whole transcript for the first time
      createSummary(){
        var test_query = []
        for (var i in this.meeting.transcript_set){

          var att_tags = []
          for (var j in this.meeting.transcript_set[i].attendeetag_set){
            att_tags.push(this.meeting.transcript_set[i].attendeetag_set[j].answer)
          }
          

          var org_tag = null;
          if(this.meeting.transcript_set[i].organizer_tag){
            org_tag = this.meeting.transcript_set[i].organizer_tag.answer
          } 

          var obj ={
            "text":  this.meeting.transcript_set[i].text,
            "org_tag": org_tag,
            "att_tag": att_tags
          }
          test_query.push(obj)
        }

        axios.post('https://swadhwa.pythonanywhere.com/summarize', {
          text: JSON.stringify(test_query),
          title: this.meeting.name,
        })
        .then((res) => {
          console.log(res.data)
          this.sum_data = res.data;
        })

        // for demo only
        // var cnt = 0
        // for (var i in test_query){
        //   var temp_text = test_query[i].text.split(".")
        //   var max_len = 0;
        //   var biggest_text = ""
        //   for (var j in temp_text){
        //     if(temp_text[j].length > max_len){
        //       biggest_text = temp_text[j]
        //       max_len = temp_text[j].length
        //     }
        //   }
        //   var text_data_obj = {
        //     "text": biggest_text
        //   } 
        //   console.log(text_data_obj)
        //   if(cnt < 25){
        //     this.sum_data.push(text_data_obj)
        //     cnt += 1
        //   }
        // }

        // for (let i = this.sum_data.length - 1; i > 0; i--) {
        //   const j = Math.floor(Math.random() * (i + 1));
        //   [this.sum_data[i], this.sum_data[j]] = [this.sum_data[j], this.sum_data[i]];
        // }

        //for the demo only ends
        
        // console.log(JSON.stringify(test_query))
      },
      resizeCardBox () {
        var h = document.getElementById('topcardid').clientHeight
        document.getElementById('cardContainer').style.height = 'calc(100vh  - ' + (h + 48 + 60 + 64) + 'px)'
        document.getElementById('revContainer').style.height = 'calc(100vh  - ' + (h + 48 + 60 + 64) + 'px)'
        document.getElementById('header_div').style.height = h + 48 + 75 - 3 + "px"
        // console.log(" divresized")
      },
      checkLoggedIn () {
        if (!this.getUser()) {
          router.push('/auth')
        } else {
          this.loadMeeting()
        }
      },
      loadMeeting () {
        axios
          .get(
            this.api_url + '/api/meeting/' + this.$route.params.id + '/',
            {
              headers: {Authorization: `JWT ${this.getUser().token}`}
            }
          )
          .then(response => {
            this.loadedData = response.data

            // console.log(this.loadedData)
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.$session.destroy()
              this.$router.push('/auth')
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => (this.loading = false))
      },
      updateTranscript (item) {
        axios
          .put(
            this.api_url + '/api/transcript/' + item.id + '/', item,
            {
              headers: {Authorization: `JWT ${this.getUser().token}`}
            }
          )
          .then(response => {
            if (response.status === 200) {
              this.loadMeeting()
              this.dialog = false
            }
            // console.log(this.loadedData)
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.$session.destroy()
              this.$router.push('/auth')
            }
            console.log(error)
            this.errored = true
          })
          .finally(() => (this.loading = false))
      },
      getOrgTag (tagID) {
        for (var i in this.org_tags) {
          if (this.org_tags[i].answer === tagID) {
            return this.org_tags[i]
          }
        }
        return null
      },
      getAttendeeTag (tagID) {
        for (var i in this.attendee_tags) {
          if (this.attendee_tags[i].answer === tagID) {
            return this.attendee_tags[i]
          }
        }
        return null
      },
      editClicked (item) {
        this.dialog = true
        this.editItem = JSON.parse(JSON.stringify(item))
        this.editItem.editTopic = this.editItem.phrase.phrase
        if (this.editItem.organizer_tag != null) {
          this.editItem.editTag = this.getOrgTag(this.editItem.organizer_tag.answer).name
        }
        console.log('before', JSON.parse(JSON.stringify(this.editItem)))

      },
      selectAllPressed () {
        this.selectAllTag = !this.selectAllTag
        this.makeSelect()
        this.filterData()
      },
      selectcheckboxChanged () {
        this.makeSelect()
        this.filterData()
      },
      savePressed () {
        this.editItem.phrase.id = this.loadedData.extractedphrase_set.find(o => o.phrase === this.editItem.editTopic).id

        if (this.editItem.organizer_tag === null) {
          if (this.editItem.editTag !== 'notag') {
            this.editItem.organizer_tag = {
              'clicker_id': 'onlineTG',
              'answer': this.loadedData.organizertagname_set.find(o => o.name === this.editItem.editTag).answer,
              'time': this.editItem.start_time,
              'start_period': this.editItem.start_time,
              'end_period': this.editItem.end_time,
              'meeting': this.editItem.meeting
            }
          }
        } else {
          console.log(this.editItem.editTag)
          this.editItem.organizer_tag.answer = this.loadedData.organizertagname_set.find(o => o.name === this.editItem.editTag).answer
          if (this.editItem.organizer_tag.answer === 'notag') {
            this.dialog = false //TODO: show error
            return
          }
          // this.editItem.organizer_tag.answer = "N"
        }

        if (this.editItem.text.length > 0) {
          this.updateTranscript(this.editItem)
        }

      },
      bClicked (item) {
        item.active = !item.active
        this.filterData()
      },
      getTimePassed (item) {
        var a = moment(item.start_time)
        var b = moment(this.meeting.meeting_date)
        var d = a.diff(b)
        var hours = a.diff(b, 'hours')
        var hours_s = ((hours < 10) ? '0' + hours : hours) + ':'
        return (hours < 1) ? moment(d).format('mm:ss') : hours_s + moment(d).format('mm:ss')
      },
      checkboxChanged () {
        this.filterData()
      },
      phraseClicked (index) {
        this.phrases[index].active = !this.phrases[index].active
        this.filterData()
      },
      searchTextChanged () {
        this.filterData()
      },
      timelineClicked (item) {
        console.log('timeline clicked', item)
        // if (this.any_circle_selected === true) {
        //   this.any_circle_selected = false
        //   for (var k in this.timelineData) {
        //     var times = this.timelineData[k].times
        //     for (var j in  times) {
        //       if (this.timelineData[k].times[j].select === true) {
        //         console.log('i was true')
        //         this.timelineData[k].times[j].select = false
        //         document.getElementById('trans' + this.timelineData[k].times[j].transcript.id).setAttribute('style', 'background-color:' + this.colors.card_bg + ';')
        //       }
        //       this.timelineData[k].times[j].fade = false
        //     }
        //   }
        // }
      },
      filterData () {
        this.filter_empty = false
        var isSelectAll = true
        for (var i in this.org_tags) {
          if (!this.org_tags[i].active) {
            isSelectAll = false
          }
        }
        this.selectAllTag = isSelectAll

        if (this.selectedElemenet != null) {
          this.selectedElemenet.setAttribute('style', 'background-color:' + this.colors.card_bg + ';')
        }

        function hasPhrase (phrases) {
          for (var i in phrases) {
            if (phrases[i].active) {
              return true
            }
          }
          return false
        }

        function hasTag (tags) {
          for (var i in tags) {
            if (tags[i].active) {
              return true
            }
          }
          return false
        }

        function checkPhrase (trans_phrase, phrases) {
          for (var i in phrases) {
            if (phrases[i].phrase === trans_phrase) {
              return !!phrases[i].active
            }
          }
          return false
        }

        function compare (tag, descending, self) {
          return function (a, b) {
            const countA = self.getNumberOfAttendeesTag(a, tag)
            const countB = self.getNumberOfAttendeesTag(b, tag)
            var comparison = 0
            if (countA > countB) {
              comparison = 1
            } else if (countB > countA) {
              comparison = -1
            }

            return comparison * descending
          }
        }

        function addBetween (transcriptItem) {
          var last = filteredTranscript[filteredTranscript.length - 1]
          if (Array.isArray(last)) {
            last.push(transcriptItem)
            filteredTranscript.pop()
            filteredTranscript.push(last)
          } else {
            var newLast = [transcriptItem]
            filteredTranscript.push(newLast)
          }
        }

        var scrollToFeedback = true
        if (this.feedback_loop.length > 0) scrollToFeedback = false
        this.feedback_loop = []

        var tempData = JSON.parse(JSON.stringify(this.loadedData))
        var filteredTranscript = []
        for (var transcript_id in tempData.transcript_set) {
          var transcript = tempData.transcript_set[transcript_id]
          if ((hasPhrase(this.phrases) && transcript.phrase != null && !checkPhrase(transcript.phrase.phrase, this.phrases)) ||
            hasPhrase(this.phrases) && transcript.phrase === null) {
            addBetween(transcript)
            continue
          }
          if (this.searchText.length > 0) {
            if (!transcript.text.toLowerCase().includes(this.searchText.toLowerCase())) {
              addBetween(transcript)
              continue
            }
            // transcript.text = transcript.text.replace(new RegExp(this.searchText, "gi"), match => {
            //   return '<span class="highlightText">' + match + '</span>';
            //   });
            // }else {
            //   continue
            // }
          }

          // if (hasTag(this.org_tags)) {
          var gotin = false
          for (var sid in this.org_tags) {
            var sBut = this.org_tags[sid]
            if ((transcript.organizer_tag != null && transcript.organizer_tag.answer === sBut.answer && sBut.active)
              || (transcript.organizer_tag == null && sBut.answer === 'notag' && sBut.active)) {
              filteredTranscript.push(transcript)
              gotin = true
              if (this.sortFilter !== 'None') {
                if (this.getNumberOfAttendeesTag(transcript, this.getTag()) !== 0) {
                  this.feedback_loop.push(JSON.parse(JSON.stringify(transcript)))
                }
              }
              break
            }
          }
          if (!gotin) {
            addBetween(transcript)
          }

          // }else{
          //   filteredTranscript.push(transcript)
          // }
        }

        this.filter_empty = true
        for (const t in filteredTranscript) {
          if (!Array.isArray(filteredTranscript[t])) {
            this.filter_empty = false
          }

        }
        if (filteredTranscript.length === 0) {
          this.filter_empty = true
        }
        tempData.transcript_set = filteredTranscript
        this.meeting = tempData

        this.feedback_obj.index = 0
        if (this.feedback_loop.length > 0) {
          this.feedback_loop.sort(compare(this.getTag(), -1, this))
          this.feedback_obj.value = '(' + (this.feedback_obj.index + 1) + ' of ' + (this.feedback_loop.length) + ') : ' + this.getNumberOfAttendeesTag(this.feedback_loop[this.feedback_obj.index], this.getTag())
        } else {
          this.feedback_obj.value = ''
        }
        if (scrollToFeedback) {
          this.showFeedbackCard(this.feedback_obj.index)
        }

      },
      getTag () {
        if (this.sortFilter !== 'None') {
          for (var i in this.attendee_tags) {
            if (this.attendee_tags[i].name === this.sortFilter) {
              return this.attendee_tags[i].answer
            }
          }
        }
      },
      feedbackUpClicked () {
        this.feedback_obj.index -= 1
        if (this.feedback_obj.index === -1) {
          this.feedback_obj.index = this.feedback_loop.length - 1
        }
        this.selectCircle(false, -1)
        this.showFeedbackCard(this.feedback_obj.index)
      },
      feedbackDownClicked () {
        this.feedback_obj.index += 1
        if (this.feedback_obj.index === this.feedback_loop.length) {
          this.feedback_obj.index = 0
        }
        this.selectCircle(false, -1)
        this.showFeedbackCard(this.feedback_obj.index)
      },
      scrollToCard: function (id, selected) {
        console.log(id, selected)
        var element = document.getElementById('trans' + id)
        if (element === null) return
        if (this.selectedElemenet !== null && this.selectedElemenet.id !== element.id) {
          this.selectedElemenet.setAttribute('style', 'background-color:' + this.colors.card_bg + ';')
          this.selectedElemenet = null
        }
        if (selected) {
          element.setAttribute('style', 'background-color:' + this.colors.card_highlight + ';')
          this.selectedElemenet = element
        } else {
          element.setAttribute('style', 'background-color:' + this.colors.card_bg + ';')
          this.selectedElemenet = null
        }

        if (selected) {
          var scrollOptions = {
            container: '#dataContent',
            easing: 'ease-in',
            offset: 0,
            force: true,
            cancelable: true,
            onStart: function (element) {
              // scrolling started
            },
            onDone: function (element) {
              // scrolling is done
            },
            onCancel: function () {
              // scrolling has been interrupted
            },
            x: false,
            y: true
          }
          VueScrollTo.scrollTo(element, 500, scrollOptions)
        }
      },
      showFeedbackCard (index) {
        // console.log("test",this.feedback_loop[index].id)

        if (this.feedback_loop.length > 0) {
          if (this.sortFilter !== 'None') {
            this.feedback_obj.value = '(' + (index + 1) + ' of ' + (this.feedback_loop.length) + ') : ' + this.getNumberOfAttendeesTag(this.feedback_loop[index], this.getTag())
          }
          this.scrollToCard(this.feedback_loop[index].id, true)
        }

      },
      getNumberOfAttendeesTag (transcript, tagID) {
        var count = 0
        for (var att in transcript.attendeetag_set) {
          if (tagID === transcript.attendeetag_set[att].answer) {
            count += 1
          }
        }
        return count
      },
      createBarChart (index, item) {

        var that = this

        if (index === 0) {
          setTimeout(function () {
            that.resizeCardBox()
          }, 100)
        }
        setTimeout(function () {
          var divID = 'bc' + index
          if (document.getElementById(divID)) {
            var element = document.getElementById(divID)
            d3.select('#' + divID).select('svg').remove()
            var dataset = [
              {
                text: that.getAttendeeTag('A').name,
                color: that.colors.bar_chart,
                border_color: that.colors.bar_chart,
                value: that.getNumberOfAttendeesTag(item, 'A')
              }, {
                text: that.getAttendeeTag('B').name,
                color: that.colors.bar_chart,
                border_color: that.colors.bar_chart,
                value: that.getNumberOfAttendeesTag(item, 'B')
              }, {
                text: that.getAttendeeTag('C').name,
                color: that.colors.bar_chart,
                border_color: that.colors.bar_chart,
                value: that.getNumberOfAttendeesTag(item, 'C')
              }, {
                text: that.getAttendeeTag('D').name,
                color: that.colors.bar_chart,
                border_color: that.colors.bar_chart,
                value: that.getNumberOfAttendeesTag(item, 'D')
              }, {
                text: that.getAttendeeTag('E').name,
                color: that.colors.bar_chart,
                border_color: that.colors.bar_chart,
                value: that.getNumberOfAttendeesTag(item, 'E')
              },
            ]

            if (that.sortFilter !== 'None') {
              dataset.find(x => x.text === that.sortFilter).color = that.colors.highlighter
              dataset.find(x => x.text === that.sortFilter).border_color = that.colors.bar_chart

            }
            // var total = 0
            // for (var i in dataset){
            //   total += dataset[i].value
            // }
            //
            // if (total > 0) {

            var w = element.clientWidth
            var h = element.clientHeight
            var barPadding = 1

            var margin = {top: 20, right: 20, bottom: 90, left: 30},
              width = w - margin.left - margin.right,
              height = h - margin.top - margin.bottom

            var x = d3.scale.ordinal().rangeRoundBands([0, width], .05)
            var y = d3.scale.linear().range([height, 0])

            var xAxis = d3.svg.axis()
              .scale(x)
              .orient('bottom')
              .tickSize(1)

            var yAxis = d3.svg.axis()
              .scale(y)
              .orient('left')
              .ticks(2)
            var svg = d3.select('#' + divID).append('svg')
              .attr('width', width + margin.left + margin.right)
              .attr('height', height + margin.top + margin.bottom)
              .append('g')
              .attr('transform',
                'translate(' + margin.left + ',' + margin.top + ')')

            x.domain(dataset.map(function (d) {
              return d.text
            }))
            y.domain([0, d3.max(dataset, function (d) {
              if (d.value > that.loadedData.number_of_attendees) {
                return d.value
              } else {
                return that.loadedData.number_of_attendees
              }
            })])

            svg.append('g')
              .attr('class', 'x axis')
              .attr('transform', 'translate(3,' + height + ')')
              .call(xAxis)
              .selectAll('text')
              .style('text-anchor', 'end')
              .style('font-size', '11px')
              .attr('dx', '-1em')
              .attr('dy', '0.0em')
              .attr('transform', 'rotate(-65)')

            svg.selectAll('bar')
              .data(dataset)
              .enter().append('rect')
              .style("outline", function (d) {
                return "1px solid" +  d.border_color
              })
              .style('fill', function (d) {
                return d.color
              })
              .attr('x', function (d) {
                return x(d.text)
              })
              .attr('width', x.rangeBand())
              .attr('y', function (d) {
                return y(d.value)
              })
              .attr('height', function (d) {
                return height - y(d.value)
              })


            svg.selectAll('.text')
              .data(dataset)
              .enter()
              .append('text')
              .attr('class', 'label')
              .attr('x', (function (d) {
                return x(d.text) + x.rangeBand() / 2 - 3
              }))
              .attr('y', function (d) {
                return y(d.value) - 13
              })
              .attr('dy', '.75em')
              .style('fill', 'black')
              .text(function (d) {
                return (d.value != 0) ? d.value : ''
              })

          }
          // }
        }, 100)

      },
      createTimeline () {
        this.timelineWidth = document.getElementById('top-card').clientWidth

        var that = this
        if (document.getElementsByTagName('svg')) {
          d3.select('#chart-timeline').select('svg').remove()
        }

        var toolTipDiv = null
        if (!document.getElementById('tooltipDiv')) {
          toolTipDiv = d3.select('body').append('div')
            .attr('class', 'ctooltip')
            .attr('id', 'tooltipDiv')
            .style('opacity', 0)
        } else {
          toolTipDiv = d3.select('#tooltipDiv')
        }

        var chart = d3.timeline()
          .beginning(moment(this.meeting.start_time).valueOf())
          .ending(moment(this.meeting.end_time).valueOf())
          .showTimeAxisTick()
          // .relativeTime()
          .tickFormat({
            format: d3.time.format('%X'),
            // tickValues:  [10, 20, 30],
            tickInterval: 30,
            tickSize: 1,
          })
          // .stack()
          .click(function (d, i, datum) {
            that.timelineCircleclicked(d, i, datum)

            // d is the current rendering object
            // i is the index during d3 rendering
            // datum is the id object
          })
          .mouseover(function (d, i, datum, item) {
            var inner = '<span class=\'ctooltipSpan\'>' + d.text + '</span>'
            toolTipDiv.transition()
              .duration(200)
              .style('opacity', 1.0)
            toolTipDiv.html(inner)
              .style('left', (item.getBoundingClientRect().x - 52) + 'px')
              .style('top', (item.getBoundingClientRect().y - 30) + 'px')
              .style('background', d.color)
          })
          .mouseout(function (d, i, datum) {
            toolTipDiv.transition()
              .duration(500)
              .style('opacity', 0)
          })
          .display('circle').margin({left: 100, right: 30, top: 0, bottom: 0})
        var t = d3.select('#chart-timeline').append('svg').attr('width', this.timelineWidth - 30).datum(this.timelineData).call(chart)
      },
      selectCircle (selection, id) {
        var fade = true
        if (!selection) {
          fade = false
        }
        for (var k in this.timelineData) {
          var times = this.timelineData[k].times
          for (var j in  times) {
            if (times[j].id === id) {
              console.log('find', times[j])
              this.timelineData[k].times[j].select = selection
              this.timelineData[k].times[j].fade = false

            } else {
              if (this.timelineData[k].times[j].select === true) {
                console.log('i was true')
                this.timelineData[k].times[j].select = false
                document.getElementById('trans' + this.timelineData[k].times[j].transcript.id).setAttribute('style', 'background-color:' + this.colors.card_bg + ';')
              }
              this.timelineData[k].times[j].fade = fade
            }
          }
        }
        this.createTimeline()
      },
      timelineCircleclicked (d, i, datum) {
        // console.log(datum.times)
        d.select = !d.select
        this.selectCircle(d.select, d.id)
        // for (var k in this.timelineData) {
        //   var times = this.timelineData[k].times
        //   for (var j in  times) {
        //     if (times[j].id === d.id) {
        //       console.log('find', times[j])
        //       this.timelineData[k].times[j].select = d.select
        //       this.timelineData[k].times[j].fade = false
        //
        //     } else {
        //       if (this.timelineData[k].times[j].select === true) {
        //         console.log('i was true')
        //         this.timelineData[k].times[j].select = false
        //         document.getElementById('trans' + this.timelineData[k].times[j].transcript.id).setAttribute('style', 'background-color:' + this.colors.card_bg + ';')
        //       }
        //       this.timelineData[k].times[j].fade = fade
        //     }
        //   }
        // }
        // this.createTimeline()
        this.scrollToCard(d.transcript.id, d.select)
      },
      changeTimelineData () {
        var tempTimes = []
        // var aoption = {label: this.getOrgTag('A').name, times: []}
        // var boption = {label: this.getOrgTag('B').name, times: []}
        // var coption = {label: this.getOrgTag('C').name, times: []}
        // var doption = {label: this.getOrgTag('D').name, times: []}
        // var eoption = {label: this.getOrgTag('E').name, times: []}
        var aoption = {times: []}
        var boption = {times: []}
        var coption = {times: []}
        var doption = {times: []}
        var eoption = {times: []}
        for (var transcript_id in this.meeting.transcript_set) {
          var transcript = this.meeting.transcript_set[transcript_id]
          if (transcript.organizer_tag) {
            var a = moment(transcript.organizer_tag.time).valueOf()
            var time = {
              'starting_time': moment(transcript.start_time).valueOf(),
              'ending_time': moment(transcript.end_time).valueOf(),
              'color': this.getOrgTag(transcript.organizer_tag.answer).color,
              'deselect_color': this.colors.timeline_deselect,
              'select': false,
              'fade': false,
              'transcript': transcript,
              'id': 'timelineDots_' + transcript.id,
              'text': this.getOrgTag(transcript.organizer_tag.answer).text,
            }
            if (transcript.organizer_tag.answer === 'A') {
              aoption.times.push(time)
            }
            if (transcript.organizer_tag.answer === 'B') {
              boption.times.push(time)
            }
            if (transcript.organizer_tag.answer === 'C') {
              coption.times.push(time)
            }
            if (transcript.organizer_tag.answer === 'D') {
              doption.times.push(time)
            }
            if (transcript.organizer_tag.answer === 'E') {
              eoption.times.push(time)
            }

          }
        }
        tempTimes.push(aoption, boption, coption, doption, eoption)
        this.timelineData = tempTimes
        this.createTimeline()
      },
      makeSelect () {
        for (var i in this.org_tags) {
          this.org_tags[i].active = this.selectAllTag
        }
      },
      addPhrases () {
        var tempPhrases = this.loadedData.extractedphrase_set
        for (var i in tempPhrases) {
          tempPhrases[i].active = false
          tempPhrases[i].text = tempPhrases[i].phrase
        }
        this.phrases = tempPhrases
      },
      addorgtag () {
        var tempPhrases = this.loadedData.organizertagname_set
        for (var i in tempPhrases) {
          tempPhrases[i].active = false
          tempPhrases[i].text = tempPhrases[i].name
        }
        tempPhrases.push(
          {
            answer: 'notag',
            name: 'No Tag',
            color: this.colors.no_tag,
            text: 'No Tag'
          }
        )
        this.org_tags = tempPhrases
      },
      getQueries (item) {
        var query = []
        for (var i in this.phrases) {
          if (this.phrases[i].active && item.phrase != null && item.phrase.phrase === this.phrases[i].text) {
            query = item.phrase.phrase.split(' ')
            break
          }
        }
        query.push(this.searchText)
        //query.push(myNote)
        for (var i in this.sum_data){
          query.push(this.sum_data[i].text)
        }
        console.log(query)
        return query
      },
    },
    watch: {
      loadedData: function (val) {
        console.log('changed loadeddata', val)

        this.loadedData = val
        this.attendee_tags = this.loadedData.attendeetagname_set
        this.addorgtag()
        this.meeting = this.loadedData
        this.addPhrases()
        this.makeSelect()
        this.createSummary()
      }
      ,
      meeting: function (val) {
        console.log('changed meeting', val)
        this.meeting = val

        this.changeTimelineData()
      }
      ,
      attendee_tags: function (val) {
        this.attendee_tags = val
        var temp = []
        for (var i in this.attendee_tags) {
          temp.push(this.attendee_tags[i].name)
        }
        temp.push('None')
        this.dropdown_sort = temp
      }
      ,
      sortFilter: function (val) {
        this.sortFilter = val
        this.feedback_loop = []

        this.filterData()
        // this.makeFeedbackItems()
      }
      ,
      sortDirection: function (val) {
        this.sortDirection = val
        this.filterData()
      }
      ,
      selectAllTag: function (val) {
        console.log('Select all tag')
        this.selectAllTag = val

      }
      ,
      side_menu: function (val) {
        this.side_menu = val
        var that = this
        setTimeout(function () {
          that.createTimeline()
        }, 100)
      }
    }
  }
</script>

<style scoped>

  /**{ text-transform: none !important; }*/

  .test_class .v-label {
    color: blue;
  }

  .note {
    white-space: pre-line;
    margin: 0px 0px 0px 10px;
    font-size: 15px;
  }

  .axis path,
  .axis line {
    fill: none;
    stroke: #000;
    shape-rendering: crispEdges;
  }

  .line {
    fill: none;
    stroke: steelblue;
    stroke-width: 2px;
  }

  .axis text {
    font-family: sans-serif;
    font-size: 5px;
  }

  .filterHolder {
    background-color: #f5f8fa;
    border-radius: 2px;
    border-style: solid;
    border-width: thin;
  }

  .collapsed_div {
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .timeline-card {
    position: -webkit-sticky;
    position: sticky;
    top: 64px;
  }

  .v-input--selection-controls {
    margin-top: 0px;
    padding-top: 0px;
    flex: none;
  }

  .v-btn {
    font-weight: bold;
  }

  .highlightText {
    background: yellow;
  }

  .timeline-label {
    font-family: sans-serif;
    font-size: 12px;
  }

  .coloredDiv {
    height: 20px;
    width: 20px;
    float: left;
  }
</style>

<style>
  .sum-row:hover{
      /* background-color:lightgray; */
      font-weight: 900;
      color: #2B4A5B;
      cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/OrganizerMeetingDetail.vue